import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=6cbb699e"
import script from "./ship.vue?vue&type=script&lang=js"
export * from "./ship.vue?vue&type=script&lang=js"
import style0 from "./ship.vue?vue&type=style&index=0&id=6cbb699e&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports